import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'boolToStr' })
export class BooleanToTextPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? 'Si' : 'No';
  }
}
